import {
  CREATE_CORPATATE,
  SET_CORPATATE,
  SET_LIST_CORPATATE,
  UPDATE_CATEGORY,
  SET_ALL_CORPATATE_SELECT
} from "../../reducerTypes"

const initialState = {
  getData: {},
  getList: [],
  selectData: []
}

const corporateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LIST_CORPATATE:
      return {
        ...state,
        getList: action.payload
      }
    case CREATE_CORPATATE:
      return {
        ...state,
        getData: action.payload
      }
    case SET_CORPATATE:
      return {
        ...state,
        getData: action.payload
      }
    case UPDATE_CATEGORY:
      return {
        ...state,
        getData: action.payload
      }
    case SET_ALL_CORPATATE_SELECT:
      const contentData = action.payload && action.payload.content ? action.payload.content : [];
      const selectData = [];
      contentData.map((data) => {
        selectData.push({
          value: data.id,
          label: `${data.name}`
        })
        return data
      });
      return {
        ...state,
        selectData: selectData
      }
    default:
      return state
  }
}

export default corporateReducer
